import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionCard } from '@wit-support/ui';
import { EntityLabel } from '@wit-support/ui-domain';
import { displayName, localRefLabel } from '../naming.js';
const str = (v) => (typeof v === 'string' && v !== '' ? v : null);
/**
 * Имена из `compiled` (форма auto-ads: `campaign.name`, `adSets[].localRef` +
 * `params.name`, `adSets[].ads[]` так же). Чужая форма — пусто, экран
 * покажет подпись вида и id. Meta не спрашиваем: имена — наши.
 */
export function compiledNamesOf(compiled) {
    const adSets = new Map();
    const ads = new Map();
    const c = (compiled ?? null);
    const campaignRaw = str(c?.campaign?.name);
    if (Array.isArray(c?.adSets)) {
        for (const s of c.adSets) {
            const set = (s ?? null);
            const ref = str(set?.localRef);
            const name = str(set?.params?.name);
            if (ref != null && name != null)
                adSets.set(ref, displayName(name) ?? name);
            if (!Array.isArray(set?.ads))
                continue;
            for (const a of set.ads) {
                const ad = (a ?? null);
                const aref = str(ad?.localRef);
                const aname = str(ad?.params?.name);
                if (aref != null && aname != null)
                    ads.set(aref, displayName(aname) ?? aname);
            }
        }
    }
    return {
        campaign: campaignRaw != null ? (displayName(campaignRaw) ?? campaignRaw) : null,
        adSets,
        ads,
    };
}
/**
 * «Созданные объекты» запуска: кампания, группы, объявления — нашим именем из
 * спеки запуска и id Meta (копируется). Объекта ещё нет — «—».
 */
export function CreatedObjects({ launch, rollback = null, }) {
    const groups = launch.adSetGroups ?? null;
    const names = compiledNamesOf(launch.compiled);
    const { created } = launch;
    return (_jsxs(SectionCard, { title: "\u0421\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B", children: [rollback != null ? (_jsx("span", { className: "mb-2 block text-sm text-[var(--color-text-muted)]", "data-testid": "created-rolled-back", children: rollback === 'done'
                    ? 'Удалены откатом — в Meta этих объектов больше нет.'
                    : 'Откатывается… — объекты удаляются из Meta.' })) : null, _jsxs("ul", { className: "flex flex-col gap-1 text-sm", "data-testid": "created", children: [_jsxs("li", { className: "flex flex-wrap items-center gap-x-1", children: [_jsx("span", { children: "\u041A\u0430\u043C\u043F\u0430\u043D\u0438\u044F:" }), created.campaignId != null ? (_jsx(EntityLabel, { kind: "campaign", id: created.campaignId, name: names.campaign, variant: "inline" })) : (_jsx("span", { children: "\u2014" }))] }), Object.entries(created.adSetIds).map(([ref, mid]) => (_jsxs("li", { title: ref, className: "flex flex-wrap items-center gap-x-1", children: [_jsxs("span", { children: [localRefLabel(ref, 'adset', groups), ":"] }), _jsx(EntityLabel, { kind: "adset", id: mid, name: names.adSets.get(ref) ?? null, variant: "inline" })] }, ref))), Object.entries(created.adIds).map(([ref, mid]) => (_jsxs("li", { title: ref, className: "flex flex-wrap items-center gap-x-1", children: [_jsxs("span", { children: [localRefLabel(ref, 'ad', groups), ":"] }), _jsx(EntityLabel, { kind: "ad", id: mid, name: names.ads.get(ref) ?? null, variant: "inline" })] }, ref)))] })] }));
}
//# sourceMappingURL=created-objects.js.map